export const CLIENTS_MODULE_PATHS = {
  CLIENTS: '/clients'
};

export const LOGIN_MODULE_PATHS = {
  LOGIN: '/login'
};

export const NAV_BAR_MODULE_PATHS = {
  NAV_BAR: '/navBar'
};
